import { render, staticRenderFns } from "./AllIndex.vue?vue&type=template&id=81ea9794&scoped=true"
import script from "./AllIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./AllIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AllIndex.vue?vue&type=style&index=0&id=81ea9794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ea9794",
  null
  
)

export default component.exports